import React from "react";
import { Settings2, Zap, Timer, CheckSquare, ListPlus, ShieldCheck } from "lucide-react";

const OutcomesPage = () => {
  return (
    <div className="space-y-10 pb-20">
      <section>
        <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-green-50 border border-green-100 mb-4">
          <Settings2 size={14} className="text-green-600" />
          <span className="text-[10px] font-black text-green-600 uppercase tracking-widest">Standardization</span>
        </div>
        <h1 className="text-4xl font-black text-gray-900 tracking-tight mb-4">Define Performance Outcomes</h1>
        <p className="text-lg text-gray-600 max-w-2xl leading-relaxed">
          Standardize the metrics for your organization. By choosing specific Combine and Skill 
          drills, you ensure every coach is evaluating athletes on the same scale.
        </p>
      </section>

      {/* Outcome Selection Strategy */}
      <div className="grid md:grid-cols-3 gap-6">
        <div className="p-6 bg-white border border-gray-100 rounded-2xl shadow-sm flex flex-col items-center text-center">
          <div className="bg-orange-100 p-3 rounded-xl text-orange-600 mb-4"><Zap size={24}/></div>
          <h4 className="font-bold text-sm mb-2">Explosive Metrics</h4>
          <p className="text-[11px] text-gray-500 italic">Example: Vertical Jump, Broad Jump</p>
        </div>
        <div className="p-6 bg-white border border-gray-100 rounded-2xl shadow-sm flex flex-col items-center text-center">
          <div className="bg-blue-100 p-3 rounded-xl text-blue-600 mb-4"><Timer size={24}/></div>
          <h4 className="font-bold text-sm mb-2">Speed Outcomes</h4>
          <p className="text-[11px] text-gray-500 italic">Example: 40-Yard Dash, 5-10-5 Pro Shuttle</p>
        </div>
        <div className="p-6 bg-white border border-gray-100 rounded-2xl shadow-sm flex flex-col items-center text-center">
          <div className="bg-purple-100 p-3 rounded-xl text-purple-600 mb-4"><CheckSquare size={24}/></div>
          <h4 className="font-bold text-sm mb-2">Technical Skills</h4>
          <p className="text-[11px] text-gray-500 italic">Sport-specific drills (e.g., Passing Accuracy)</p>
        </div>
      </div>

      

      {/* The Impact Section */}
      <section className="bg-slate-900 rounded-3xl p-10 text-white">
        <div className="flex flex-col md:flex-row gap-10 items-center">
          <div className="flex-1 space-y-4">
            <h3 className="text-2xl font-bold">The Data Foundation</h3>
            <p className="text-slate-400 text-sm leading-relaxed">
              When you select an outcome (e.g., 40-Yard Dash), it automatically populates the 
              checklists for every <strong>Coach</strong> and <strong>Athlete</strong> under your organization. 
              This creates a unified data sheet that makes recruitment reporting seamless.
            </p>
          </div>
          <div className="bg-slate-800 p-6 rounded-2xl border border-slate-700 w-full md:w-80">
             <div className="flex items-center justify-between mb-4 border-b border-slate-700 pb-2">
                <span className="text-[10px] font-black uppercase tracking-widest text-slate-400">Outcome Sync</span>
                <ShieldCheck size={16} className="text-green-500" />
             </div>
             <div className="space-y-2">
                <div className="flex items-center gap-2 text-xs text-slate-300">
                    <div className="w-2 h-2 rounded-full bg-blue-500"></div>
                    <span>Push to 12 Coaches</span>
                </div>
                <div className="flex items-center gap-2 text-xs text-slate-300">
                    <div className="w-2 h-2 rounded-full bg-purple-500"></div>
                    <span>Push to 140 Athletes</span>
                </div>
             </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default OutcomesPage;